import axios from 'axios'
import router from '../../router/index'
import $api from "@/axios/request"

export default {
    namespaced: true,
    state() {
        return {
            token: localStorage.getItem('jwt-token'),
            role: null,
            loginData: {},
        }
    },
    mutations: {
      setToken(state, token) {
          state.token = token
          localStorage.setItem('jwt-token', token)
      },
        setRole(state, role) {
            state.role = role
        },
        setLoginData(state, data) {
          state.loginData = data
        },
      logout(state) {
          state.token = null
          state.role = null
          state.loginData = {}
          localStorage.removeItem('jwt-token')
      }
    },
    actions: {
        async login({ commit, dispatch }, payload) {
            try {
                const {data} = await axios.post(`http://213.139.209.236:5000/api/login`,  payload, {withCredentials: true})
                commit('setLoginData', data.user)
                commit('setToken', data.accessToken)
                commit('setRole', data.user.role)
                commit('clearMessage', null, {root:true})
                dispatch('setMessage', {
                    value: 'Вход выполнен',
                    type: 'primary'
                }, {root: true})
            }
            catch(e) {
                dispatch('setMessage', {
                    value: e.response.data.message,
                    type: 'danger'
                }, {root: true})
                throw new Error(e)
            }
        },

        async confirmRegistration({commit, dispatch}, payload) {
            try {
                const {data} = await $api.post(`http://213.139.209.236:5000/api/confirmRegistration`, payload)
                commit('clearMessage', null, {root:true})
                dispatch('setMessage', {
                    value: 'Пользователь создан',
                    type: 'primary'
                }, {root: true})
            }
            catch(e) {
                dispatch('setMessage', {
                    value: e.response.data.message,
                    type: 'danger'
                }, {root: true})
                throw new Error(e)
            }
        },

        async logout({dispatch}) {
            try {
                const data = await axios.post('http://213.139.209.236:5000/api/logout', null, {withCredentials: true})
            }
           catch (e) {
               dispatch('setMessage', {
                   value: e.response.data.message,
                   type: 'danger'
               }, {root: true})
               throw new Error(e)
           }
        }
    },
    getters: {
        token(state) {
            return state.token
        },
        isAuthenticated(_, getters) {
            return !!getters.token
        }
    }
}